import { LinkType } from '@/library/utils/urlUtils'
import { truncateTextWithEllipsis } from '@/util/strings'

export function getLinkTypeLabel(linkType: LinkType): string {
  switch (linkType) {
    case LinkType.GOOGLE_DOC:
      return 'Google Doc'
    case LinkType.GOOGLE_SHEET:
      return 'Google Sheet'
    case LinkType.GOOGLE_SLIDE:
      return 'Google Slides'
    case LinkType.GOOGLE_FORM:
      return 'Google Form'
    case LinkType.GOOGLE_DRIVE:
      return 'Google Drive'
    case LinkType.PDF:
      return 'PDF'
    default:
      return ''
  }
}

export function getHostnameOrTruncatedUrl(url: string, maxLength = 40): string {
  const trimmed = (url || '').trim()
  if (!trimmed) return ''

  const normalized = trimmed.includes('://') ? trimmed : `https://${trimmed}`
  try {
    const parsed = new URL(normalized)
    const hostname = parsed.hostname.replace(/^www\./, '')
    return truncateTextWithEllipsis(hostname, maxLength)
  } catch {
    return truncateTextWithEllipsis(trimmed, maxLength - 3)
  }
}

export function getAttachmentLinkDisplayText(args: {
  url: string
  linkType: LinkType
  timeText?: string
}): string {
  const url = args.url || ''
  if (!url) return ''

  const typeLabel = getLinkTypeLabel(args.linkType)
  if (typeLabel) {
    return args.timeText ? `${typeLabel} - ${args.timeText}` : typeLabel
  }

  // For generic links, limit domain length when timestamp is present to ensure both fit
  const hasTimeText = args.timeText && args.timeText.trim() !== ''
  const maxDomainLength = hasTimeText ? 15 : 40
  const genericText = getHostnameOrTruncatedUrl(url, maxDomainLength)
  return hasTimeText ? `${genericText} - ${args.timeText}` : genericText
}
